<div class="item-container">
    <div class="item-header mb-5">
        <h5 class="text-center">Company & Location</h5>
        <div class="edit-icons" mat-dialog-close="">
            <i class="material-icons">close</i>
        </div>
    </div>
    <div>
        <button mat-raised-button color="primary" class="no-sh-btn ml-auto" type="submit" (click)="onAddLocation()">
            <i class="material-icons me-2 text-white">map</i>{{"COMMON.ADD" | translate}} Locations
        </button>
    </div>
    <mat-accordion class="mt-4">
        <mat-expansion-panel class="mt-3" (opened)="panelOpenState = true" (closed)="panelOpenState = false" *ngFor="let item of companyLocArr">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <div class="profile-img me-2" [appBackgroundImg]="item.company_logo" iType="company_logo"></div>
                    <div class="mt-1">{{item.company_name}} </div>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="inner-container">
                <table>
                    <tr>
                        <th class="Features">Address</th>
                        <th class="Basic">City</th>
                        <th class="Basic">Country </th>
                        <th class="Basic">Action </th>
                    </tr>
                    <tr *ngFor="let val of item.add">
                        <td class="Features">{{val.add}}</td>
                        <td class="Basic">{{val.city}}</td>
                        <td class="Basic">{{val.country}}</td>
                        <td>
                            <div class="action-btn m-auto " matTooltip="Delete" (click)="onDeleteItem(item.id,val.id)">
                                <img src="assets/images/icons/delete-icon.svg" class="img-fluid" alt="">
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
        </mat-expansion-panel>
    </mat-accordion>
</div>